
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";
import { ImagePlus, BookOpen, FileText } from "lucide-react";

interface EmptyStateProps {
  title?: string;
  description?: string;
  actionLabel?: string;
  actionPath?: string;
  showAction?: boolean;
}

export const EmptyState = ({
  title = "Nenhum conteúdo encontrado",
  description = "Não encontramos nenhum conteúdo com esses critérios.",
  actionLabel = "Criar novo Pin",
  actionPath = "/create/pin",
  showAction = true
}: EmptyStateProps) => {
  const navigate = useNavigate();
  
  // Determine which icon to show based on the action path
  const getIcon = () => {
    if (actionPath.includes('pin')) return <ImagePlus className="h-12 w-12 text-primary/60" />;
    if (actionPath.includes('webtoon')) return <BookOpen className="h-12 w-12 text-primary/60" />;
    if (actionPath.includes('webnovel')) return <FileText className="h-12 w-12 text-primary/60" />;
    return <ImagePlus className="h-12 w-12 text-primary/60" />;
  };
  
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center border border-dashed border-border rounded-lg bg-background/50">
      <div className="h-24 w-24 rounded-full bg-primary/10 flex items-center justify-center mb-6">
        {getIcon()}
      </div>
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="text-muted-foreground max-w-md mb-8">{description}</p>
      
      {showAction && (
        <Button onClick={() => navigate(actionPath)} size="lg" className="gap-2">
          {getIcon()}
          {actionLabel}
        </Button>
      )}
    </div>
  );
};
